import Link from "next/link";

export default function TopicTags({ tags }) {
  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "");

  return (
    <div className="mb-8">
      <h3 className="text-md font-bold text-gray-900 mb-4">विषय:</h3>

      <div className="flex flex-wrap gap-3">
        {tags.map((tag, index) => {
          const slug = slugify(tag);

          return (
            <Link
              key={index}
              href={`/tag/${slug}`}
              className="px-2 py-1.5 rounded-md bg-white border border-gray-300 text-xs text-gray-900 font-semibold uppercase tracking-wide hover:bg-gray-50 transition-colors"
            >
              {tag}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
